<template>
  <router-link :to="innerTo" :target="innerTarget" v-if="innerTo != null">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  data () {
    return {
      innerTo: null,
      innerTarget: "_self"
    };
  },
  props: {
    to: Object,
    target: {
      type: String,
      default: "_self"
    }
  },
  watch: {
    to (v) {
      if (v != null) {
        if (typeof v == "string") {
          if (window.testovaci_klient && !v.startsWith("/testovaci-klient")) {
            v = "/testovaci-klient" + v;
          }
        }
        else {
          if (window.testovaci_klient && !v.path.startsWith("/testovaci-klient")) {
            v.path = "/testovaci-klient" + v.path;
          }
        }
      }
      this.innerTo = v;
    },
    target (v) {
      this.innerTarget = v;
    }
  },
  mounted () {
    this.innerTo = this.to;
    if (typeof this.innerTo != "undefined" && this.innerTo != null) {
      if (typeof this.innerTo == "string") {
        if (window.testovaci_klient && !this.innerTo.startsWith("/testovaci-klient")) {
          this.innerTo = "/testovaci-klient" + this.innerTo;
        }
      }
      else {
        if (window.testovaci_klient && !this.innerTo.path.startsWith("/testovaci-klient")) {
          this.innerTo.path = "/testovaci-klient" + this.innerTo.path;
        }
      }
    }
    this.innerTarget = this.target;
  }
}
</script>
